const LOGIN = "/login";
const FORGOT_PASSWORD = "/forgot-password";
const RESET_PASSWORD = "/reset-password";

const ADM_PATH = "/adm";
const ADM_SETTING = ADM_PATH + "/setting";

/**Post */
const ADM_POST = ADM_PATH + "/post";
const ADM_POST_LIST = ADM_POST + "";
const ADM_POST_CREATE = ADM_POST + "/create";
const ADM_POST_EDIT = ADM_POST + "/edit";

/**Invenotry */
const ADM_INVENTORY = ADM_PATH + "/inventory";
const ADM_INVENTORY_LIST = ADM_INVENTORY;
const ADM_INVENTORY_CREATE = ADM_INVENTORY + "/create";
const ADM_INVENTORY_EDIT = ADM_INVENTORY + "/edit";
const ADM_INVENTORY_IMPORT = ADM_INVENTORY + "/import";

/**Lead */
const ADM_LEAD = ADM_PATH + "/lead";
const ADM_LEAD_LIST = ADM_LEAD + "";

const ADM_MEDIA = ADM_PATH + "/media";
const ADM_MEDIA_LIST = ADM_MEDIA + "";

export const PAGE_ROUTE = {
  ADM_PATH,

  /**Post */
  ADM_POST,
  ADM_POST_LIST,
  ADM_POST_CREATE,
  ADM_POST_EDIT,

  /**Invenotry */
  ADM_INVENTORY,
  ADM_INVENTORY_LIST,
  ADM_INVENTORY_CREATE,
  ADM_INVENTORY_EDIT,
  ADM_INVENTORY_IMPORT,

  /**Lead */
  ADM_LEAD,
  ADM_LEAD_LIST,

  ADM_SETTING,

  /**Media */
  ADM_MEDIA,
  ADM_MEDIA_LIST,
};

export const PUBLIC_ROUTE = {
  LOGIN,
  FORGOT_PASSWORD,
  RESET_PASSWORD,
};
